'use client';

import ActionButton from '@/components/form/ActionButton/ActionButton';
import GfPurchaseHistoryDetail from '@/components/ui/GfPurchaseHistoryDetail/GfPurchaseHistoryDetail';
import layoutStyles from '@/styles/modules/layout.module.scss';
import utilsStyles from '@/styles/modules/utils.module.scss';
import type { OrderInquiryResult } from '../../types';
import { toHistoryListItem } from '../../utils/orderInquiryConverter';

function GuestOrderInquiryResult({
  result,
  onBack,
}: {
  result: OrderInquiryResult;
  onBack: () => void;
}) {
  return (
    <>
      <div className={utilsStyles.mtSmall}>
        <GfPurchaseHistoryDetail detail={toHistoryListItem(result)} isGuest={true} />
      </div>
      <div className={`${layoutStyles.centeredBtnWrapper} ${utilsStyles.mtMedium}`}>
        <ActionButton onClick={onBack} outlined={true} borderColor='gray300'>
          別の注文を照会する
        </ActionButton>
      </div>
    </>
  );
}

export default GuestOrderInquiryResult;
